import { DateTime, Duration } from "luxon"
import Amendment from "@/inside/models/Text/Amendment";

export default class Requirement {
    /**
     * @property {string|null} content
     * @property {DateTime|null} date.abrogation
     * @property {DateTime|null} date.effective
     * @property {DateTime|null} date.creation
     * @property {string|null} id
     * @property {boolean|null} isAssessable
     * @property {DateTime|null} lastAmendment
     * @property {string|null} reference
     * @property {string|null} status
     * @property {string|null} section
     * @property {number|null} position
     */
    constructor() {
        this.content = null;
        this.date = {
            abrogation: null,
            effective: null,
            creation: null
        };
        this.id = null;
        this.isAssessable = true;
        this.lastAmendment = null;
        this.reference = null;
        this.type = "assessable";
        this.status = null;
        this.section = null;
        this.position = 1;
    }

    /**
     * Returns a new `Requirement` instance hydrated with data from given `api_resource`.
     *
     * @param {Object} api_resource
     * @return {Requirement}
     */
    static fromAPI(api_resource) {
        let out = new Requirement();
        Object.assign(out, {
            content: api_resource.content,
            id: api_resource.id
        });

        if (api_resource.date.creation) {
            out.date.creation = DateTime.fromISO(api_resource.date.creation);
        }

        if (api_resource.date.abrogation !== null) {
            out.date.abrogation = DateTime.fromISO(api_resource.date.abrogation);
        }

        if (api_resource.date.effective) {
            out.date.effective = DateTime.fromISO(api_resource.date.effective);
        }

        if(api_resource.isAssessable){
            out.isAssessable = api_resource.isAssessable;
        }

        if(api_resource.lastAmendment){
            out.lastAmendment = Object.freeze(Amendment.fromAPI(api_resource.lastAmendment));
        }

        if(api_resource.type){
            out.type = api_resource.type;
        }

        if(api_resource.reference){
            out.reference = api_resource.reference;
        }

        if(api_resource.status){
            out.status = api_resource.status;
        }

        if(api_resource.section){
            out.section = api_resource.section;
        }

        return out;
    }

    /**
     * Returns a boolean indicating whether or not this requirement is considered "recently amended".
     *
     * @return {boolean}
     */
    get isRecentlyAmended() {
        return (
            this.lastAmendment instanceof Amendment
            && this.lastAmendment.date.signature !== null
            && (this.lastAmendment.date.signature > DateTime.now().minus(Requirement.recentlyAmendedDuration))
        );
    }

    /**
     * Returns a boolean indicating whether this requirement is abrogated.
     *
     * @return {boolean}
     */
    get isAbrogated() {
        return (
            this.date.abrogation !== null
            && (this.date.abrogation < DateTime.now())
        );
    }

    /**
     * @return {*}
     */
    static get recentlyAmendedDuration() {
        return Duration.fromObject({months: 2});
    }
}
